import { IComponentOptions } from "angular";
import { ProcessGridComponentController } from "./controller";

export const vsComponentName = "processGrid";

export const processGridComponentOptions: IComponentOptions = {
  controller: ProcessGridComponentController,
  controllerAs: "processGridController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridConfiguration: "<",
    processGroups: "<",
  },
};
